import chat from '@/api/parent-communication-chat'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState,
    edit_data: {},
    user_type: 'parent-api',
    ac_status_id: 1,
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_EDIT_DATA(state, data) {
        state.edit_data = data
    },
    SET_AC_STATUS(state, data) {
        state.ac_status_id = data
    },
}

export const actions = {
    fetch(context, attrubutes = {}) {
        return chat.get({ params: attrubutes })
    },
    sendMessage(context, data) {
        return chat.sendMessage(data)
    },
    storeChatGroup(context, data) {
        return chat.storeChatGroup(data)
    },
    update(context, data) {
        return chat.update(data)
    },

    async find(context, id) {
        if (_.isEmpty(context.state.edit_data)) {
            let response = await chat.find(id)
            context.commit('SET_EDIT_DATA', response.data)
        }
    },
    chatroom(context, attributes = {}) {
        return chat.chatroom().then(response => {
            return Promise.resolve(response)
        })
    },
    getClassRoom(context, attrubutes = {}) {
        return chat.classRooms(context.state.ac_status_id);
    },
    getUser(context, attrubutes = {}) {
        return chat.users({ params: attrubutes });
    },
}
